import '../sass/single-sale-overview.scss';

(() => {
    const $singleSaleOverviews = document.querySelectorAll('.single-sale-overview');

    if (!$singleSaleOverviews) return;

    $singleSaleOverviews.forEach($singleSaleOverview => {
        const $links = $singleSaleOverview.querySelectorAll('a');
        
        const initSingleSaleOverviewLinks = () => {
            if (!$links) return;

            $links.forEach($link => {
                $link.addEventListener('click', e => {
                    if (!window.top) return;
                    
                    e.preventDefault();
        
                    window.top.location.href = $link.href;
                });
            });
        };

        initSingleSaleOverviewLinks();
    });
})();
